export default {
      id: "icon-logo-marker-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-logo-marker",
      toString: function () {
        return this.url;
      }
    }